import styled from 'styled-components';
import { fontFamilyRaleway, mediaQueryMobileLargeMin, mediaQueryTabletMin } from 'styleUtils';
var Wrapper = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-6tbq7k-0"
})(["align-items:center;display:flex;font-family:", ";font-size:16px;font-weight:700;line-height:20px;margin-bottom:12px;padding:0 16px;width:100%;@media ", "{padding:0;}@media ", "{font-size:18px;line-height:22px;}"], fontFamilyRaleway, mediaQueryMobileLargeMin, mediaQueryTabletMin);
export default Wrapper;